import axios from "axios";
let authToken = "";
if(sessionStorage.getItem("userData")){
  let loggedInUserProfile = JSON.parse(sessionStorage.getItem("userData"));
  authToken = loggedInUserProfile.authparam;
}
//let headers = { Authorization: authToken };
// https://prod.imonitorplus.com/
// https://ltbi.nikshay.in/service 
let baseUrl = "https://ltbigen.duredemos.com/service/api/";//"https://undp.duredemos.com/service/api/"//  //"http://10.115.62.125:8080/dhis/";
// let baseUrl = "http://localhost:8080/dhis/api/";

// comman request header 
axios.interceptors.request.use(config => {
  config.headers = { Authorization: JSON.parse(sessionStorage.getItem("userData")) ? JSON.parse(sessionStorage.getItem("userData")).authparam : ''};
  return config;
}, error => {
  return Promise.reject(error);
});

// comman response 
/*axios.interceptors.response.use(
  function(response) { return response;},
  function(error) {
      // handle error
      if (error.response) {
        console.log(error.response)
          //alert`(error.response.data.message);
      }else{
        console.log(error);
      }
});*/
class ApiServices {
  constructor() {}
  RestGetCall(url,inputObj) {
    return axios
      .get(baseUrl+url, {
        //headers: headers,
        params: inputObj
      })
      .then(response => {
        return response.data;
      })
  }
  RestPostCall(url, inputObj) {
    return axios({
      method: "post",
      url: baseUrl + url,
      // headers: headers,
      // headers: { Authorization: },
      data: inputObj
    }).then(response => {
      return response.data;
    });
  }
  RestPostCallWithAuth(url, inputObj,Auth) {
    return axios({
      method: "post",
      url: baseUrl + url,
      // headers: headers,
      headers: { 'Authorization': Auth},
      data: inputObj
    }).then(response => {
      return response.data;
    });
  }
  RestPostCallWithHeader(url, inputObj,headers) {
    return axios({
      method: "post",
      url: baseUrl+url,
      headers: headers,
      data: inputObj
    }).then(response => {
      return response.data;
    });
  }
  RestPostMaltipart(url, inputObj) {
    return axios({
      method: "post",
      url: baseUrl+url,
      headers: {'Content-Type': 'multipart/form-data'},
      data: inputObj
    }).then(response => {
      return response.data;
    })
  }
  RestGetWithoutBaseUrl(url,inputObj) {
    return axios
      .get(url, {
        //headers: headers,
        params: inputObj
      })
      .then(response => {
        return response.data;
      })
  }
  GetBaseUrl() { 
    return baseUrl
  }
}

export default new ApiServices();
